import { ReactNode, FC, createContext, useState, useMemo } from 'react';
import * as types from '@models/types';

type OccupationsContextType = {
    mostRequiredISCO4JobInfo?: types.MostRequiredISCO4JobInfoTypes | null | undefined;
    setMostRequiredISCO4JobInfo?: React.Dispatch<React.SetStateAction<types.MostRequiredISCO4JobInfoTypes | null | undefined>>;
    topNEmployers?: types.TopNEmployersTypes[] | undefined;
    setTopNEmployers?: React.Dispatch<React.SetStateAction<types.TopNEmployersTypes[] | undefined>>;
    mostRequiredJobInfo?: types.MostRequiredJobInfoTypes;
    setMostRequiredJobInfo?: React.Dispatch<React.SetStateAction<types.MostRequiredJobInfoTypes | undefined>>;
    ISCO3OccupationList?: types.SelectedProfileChildrenTypes[] | undefined;
    setISCO3OccupationList?: React.Dispatch<React.SetStateAction<types.SelectedProfileChildrenTypes[] | undefined>>;
    sectorAndOccupationInfo?: types.SectorAndOccupationTypes | undefined;
    setSectorAndOccupationInfo?: React.Dispatch<React.SetStateAction<types.SectorAndOccupationTypes | undefined>>;
    topOccupationsBySectors?: types.TopOccupationsBySectorsTypes[] | undefined;
    setTopOccupationsBySectors?: React.Dispatch<React.SetStateAction<types.TopOccupationsBySectorsTypes[] | undefined>>;
    yearlyOccupationTrend?: types.SectorAndOccupationObjTypes[] | undefined;
    setYearlyOccupationTrend?: React.Dispatch<React.SetStateAction<types.SectorAndOccupationObjTypes[] | undefined>>;
    topSkills?: types.TopSkillsGroupsTypes[] | undefined;
    setTopSkills?: React.Dispatch<React.SetStateAction<types.TopSkillsGroupsTypes[] | undefined>>;
    totalJobPosts?: types.TotalJobPostsTypes | undefined;
    setTotalJobPosts?: React.Dispatch<React.SetStateAction<types.TotalJobPostsTypes | undefined>>;
    memberMigrationSectors?: types.MemberMigrationSectorsTypes[] | undefined;
    setMemberMigrationSectors?: React.Dispatch<React.SetStateAction<types.MemberMigrationSectorsTypes[] | undefined>>;
    memberMigrationOccupations?: types.MemberMigrationOccupationsTypes[] | undefined;
    setMemberMigrationOccupations?: React.Dispatch<React.SetStateAction<types.MemberMigrationOccupationsTypes[] | undefined>>;
};

const OccupationsContext = createContext<OccupationsContextType>({});


type OccupationsProps = {
    children: ReactNode;
};

const Occupations: FC<OccupationsProps> = ({ children }) => {
    const [mostRequiredISCO4JobInfo, setMostRequiredISCO4JobInfo] = useState<types.MostRequiredISCO4JobInfoTypes | null | undefined>(null);
    const [topNEmployers, setTopNEmployers] = useState<types.TopNEmployersTypes[] | undefined>([]);
    const [mostRequiredJobInfo, setMostRequiredJobInfo] = useState<types.MostRequiredJobInfoTypes | undefined>();
    const [ISCO3OccupationList, setISCO3OccupationList] = useState<types.SelectedProfileChildrenTypes[] | undefined>([]);
    const [sectorAndOccupationInfo, setSectorAndOccupationInfo] = useState<types.SectorAndOccupationTypes | undefined>({ sectors: [], occupations: [] });
    const [topOccupationsBySectors, setTopOccupationsBySectors] = useState<types.TopOccupationsBySectorsTypes[] | undefined>([]);
    const [yearlyOccupationTrend, setYearlyOccupationTrend] = useState<types.SectorAndOccupationObjTypes[] | undefined>([]);
    const [topSkills, setTopSkills] = useState<types.TopSkillsGroupsTypes[] | undefined>([]);
    const [totalJobPosts, setTotalJobPosts] = useState<types.TotalJobPostsTypes[] | undefined>([]);
    const [memberMigrationSectors, setMemberMigrationSectors] = useState<types.MemberMigrationSectorsTypes[] | undefined>([]);
    const [memberMigrationOccupations, setMemberMigrationOccupations] = useState<types.MemberMigrationOccupationsTypes[] | undefined>([]);


    const OccupationsProviderValue = useMemo(
        () => ({
            mostRequiredISCO4JobInfo, setMostRequiredISCO4JobInfo,
            topNEmployers, setTopNEmployers,
            mostRequiredJobInfo, setMostRequiredJobInfo,
            ISCO3OccupationList, setISCO3OccupationList,
            sectorAndOccupationInfo, setSectorAndOccupationInfo,
            topOccupationsBySectors, setTopOccupationsBySectors,
            yearlyOccupationTrend, setYearlyOccupationTrend,
            topSkills, setTopSkills,
            totalJobPosts, setTotalJobPosts,
            memberMigrationSectors, setMemberMigrationSectors,
            memberMigrationOccupations, setMemberMigrationOccupations
        }),
        [
            mostRequiredISCO4JobInfo, setMostRequiredISCO4JobInfo,
            topNEmployers, setTopNEmployers,
            mostRequiredJobInfo, setMostRequiredJobInfo,
            ISCO3OccupationList, setISCO3OccupationList,
            sectorAndOccupationInfo, setSectorAndOccupationInfo,
            topOccupationsBySectors, setTopOccupationsBySectors,
            yearlyOccupationTrend, setYearlyOccupationTrend,
            topSkills, setTopSkills,
            totalJobPosts, setTotalJobPosts,
            memberMigrationSectors, setMemberMigrationSectors,
            memberMigrationOccupations, setMemberMigrationOccupations
        ]
    );

    return (
        <OccupationsContext.Provider value={OccupationsProviderValue}>
            {children}
        </OccupationsContext.Provider>
    );
};

export { Occupations, OccupationsContext };